<template>
  <section class="footer">
    <div class="foot-content">
      <div
        class="foot-menu"
      >首页&nbsp;&nbsp;{{footerNav?'/':''}}&nbsp;&nbsp;{{footerNav?footerNav:''}}</div>
      <div class="foot-items">
        <ul class="first-ul">
          <li v-for="(item,index) in footList" :key="index" class="first-item">
            <h1>{{item.title}}</h1>
            <ul class="second-ul">
              <li
                v-for="(item1,index1) in item.list"
                :key="index1"
                class="second-item"
                style="cursor:pointer"
              >
                <span @click="gotoRouter(item1,item)">{{item1.title}}</span>
              </li>
            </ul>
          </li>
          <div class="foot-img">
            <img src="@/assets/image/common/gongzhonghao.png" alt>公众号
            <img src="@/assets/image/common/douyin.png" alt>大汉控股集团抖音
          </div>
        </ul>
      </div>
    </div>
    <div class="copyright">
      <a
        class="provider"
        href="https://beian.miit.gov.cn/"
        target="_blank"
      >@大汉控股集团有限公司 网站备案:湘ICP备2020017936号 湘公安备43010202001100号</a>
      <div class="divider"></div>
      <ul>
        <li @click="$router.push('/pc/contactus')">联系我们</li>
        <li @click="$router.push('/pc/law')">法律声明</li>
        <li @click="$router.push('/pc/secret')">隐私保护</li>
      </ul>
    </div>
  </section>
</template>

<script>
import { getIndustryList } from '@/api/layout'
export default {
  name: 'Footer',
  props: {
    footerNav: String
  },
  data () {
    return {
      footList: [
        {
          title: '首页',
          list: [
            {
              url: '/',
              title: '首页'
            }
          ]
        },
        {
          title: '走进大汉',
          list: [
            { url: '/pc/comdetail', title: '集团概况', name: 'GroupIntroduce', index: 0 },
            { url: '/pc/comdetail', title: '董事长', name: 'Leader', index: 1 },
            { url: '/pc/comdetail', title: '价值主张', name: 'ShowValue', index: 2 },
            // { url: '/pc/comdetail', title: '组织架构', name: 'Origanize', index: 3 },
            { url: '/pc/comdetail', title: '大汉荣誉', name: 'ComHonor', index: 3 }
          ]
        },
        {
          title: '新闻中心',
          list: [
            {
              url: '/pc/comnews',
              title: '集团新闻',
              name: 'GroupNews',
              index: 0
            },
            { url: '/pc/comnews', title: '媒体视角', name: 'MediaView', index: 1 },
            // { url: '/pc/comnews', title: '大汉公益', name: 'MediaWelfare', index: 2 },
            { url: '/pc/comnews', title: '多媒体中心', name: 'MediaCenter', index: 2 }
          ]
        },
        {
          title: '产业布局',
          list: []
        },
        {
          title: '党群文化',
          list: [
            {
              url: '/pc/partyaccess',
              name: 'RedBag',
              index: 0,
              title: '红书包'
            },
            {
              url: '/pc/partyaccess',
              name: 'RedAdmin',
              index: 1,
              title: '红管家'
            },
            {
              url: '/pc/partyaccess',
              name: 'RedYoung',
              index: 2,
              title: '红青年'
            },
            {
              url: '/pc/partyaccess',
              name: 'RedMon',
              index: 3,
              title: '红妈妈'
            },
            {
              url: '/pc/partyaccess',
              name: 'RedFlag',
              index: 4,
              title: '红旗帜'
            },
            {
              url: '/pc/partyaccess',
              name: 'RedSpring',
              index: 5,
              title: '红春晚'
            },
            {
              url: '/pc/partyaccess',
              name: 'RedShow',
              index: 6,
              title: '红展馆'
            }
          ]
        },
        {
          title: '数字大汉',
          list: [
            // { url: '/pc/digitization', name: 'fuSaid', title: '傅胜龙语录' },
            { url: '/pc/digitization', name: 'products', title: '数字化产品' }]
        },
        {
          title: '采招平台',
          list: [{ url: 'https://zhaocai.dahanjsy.com/', title: '采招平台' }]
        },
        {
          title: '人才招聘',
          list: [
            { url: '/pc/recruitment', title: '人才招聘', name: 'system' },
            { url: '/pc/campus', title: '校园招聘' },
            { url: 'https://company.zhaopin.com/CZ137478970.htm', title: '社会招聘' }
            // { url: '/pc/excellent', title: '优秀人才' }
          ]
        },
        {
          title: '廉政建设',
          list: [
            // { url: '/pc/construction', name: 'activity', title: '往期活动' },
            { url: '/pc/report', title: '举报入口' }]
        }
      ]
    }
  },
  created () {
    this.getIndustryList()
  },
  methods: {
    gotoRouter (item, fitem) {
      let reg = RegExp(/http/)
      if (!reg.test(item.url)) {
        this.$router.push({
          path: item.url,
          query: {
            name: item.name,
            index: item.index
          }
        })
        if (fitem.title === '产业布局') {
          this.$router.push({
            path: item.url,
            query: {
              name: item.name,
              index: item.index,
              title: item.title
            }
          })
        }
      } else {
        window.open(item.url)
      }
    },
    // 获取产业布局的行业分类
    async getIndustryList () {
      const { data } = await getIndustryList({ typeCode: 'company_category' })
      // 人为绑定index
      for (let i = 0; i < data.length; i++) {
        data[i].index = i
      }
      this.findLayout(data)
    },
    // 动态添加产业布局的导航栏
    findLayout (data) {
      for (let i = 0; i < this.footList.length; i++) {
        if (this.footList[i].title === '产业布局') {
          for (let j = 0; j < data.length; j++) {
            this.footList[i].list.push({ url: '/pc/layout', title: data[j].name, name: data[j].code, index: data[j].index })
          }
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import url('../css/common.less');
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue